import { Frame } from './frame'

Frame.define('fp-frame')

declare global {
  interface HTMLElementTagNameMap {
    'fp-frame': Frame;
  }
}
export default Frame
